<template>
  <v-container fluid class="container-full-bg-gray">
  <app-row>
      <app-col cols="12">
          <app-page-card>
              <template #header>
                Mi plan Bancos
              </template>
              <app-row>
                <app-col cols="3"> 
                  <app-select
                    v-model="contract"
                    hide-details
                    return-object
                    label="Contrato"
                    item-text="date_name"
                    :items="contract_items"
                    @change="setData(contract.id)"
                  />
                </app-col>
              </app-row>
              
              <v-card class="rounded-xl card-title-footer-color mx-3 mt-4 px-0">
                <v-card-title class="px-5 pb-0">
                    <v-row>
                        <v-col cols="4">

                          <v-text-field
                                v-model="search"
                                placeholder="Buscar"
                                color="primary"
                                class="app-text-field-no-border rounded-lg ma-0 pb-3 pt-0 buscador-input"
                                hide-details="auto"
                                height="36px"
                                prepend-inner-icon="mdi-magnify"
                                clearable
                            />
                        </v-col>
                        <v-col cols="8" class="d-flex justify-end">
                            <hide-deleted-switch v-model="hideDeleted" />
                        </v-col>
                    </v-row>     
                </v-card-title>
                <v-card-text  class="px-0 pt-0 card-title-footer-color">
              
                  <!-- <v-data-table
                    :items="stats_items"
                    :headers="headers"
                    :search="search"
                    :footer-props="{
                      'items-per-page-options': [5, 10, 100, 1000],
                      'items-per-page-text': 'Empresas por página:',
                    }">
                  </v-data-table> -->

                  <v-data-table
                  :items="stats_items"
                  :headers="headers"
                  :search="search"
                  :footer-props="{
                  'items-per-page-options': [5, 10, 100, 1000],
                  'items-per-page-text': 'Empresas por página:',
                  }"
                  >
                    <template #body="{ items, headers }">
                      <tbody>
                        <tr v-for="(item, i) in items" :key="i">
                          <td 
                          v-for="header in headers" 
                          :key="header.value"
                          class="td__selectable"
                          :style="{opacity:item.del?'0.5':'1'}"
                          >
                            {{item[header.value]}}
                          </td>
                        </tr>
                        <tr class="deep-purple lighten-5 font-weight-bold" v-if="total">
                          <td v-for="header in headers" :key="header.value">
                            {{total[header.value]}}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                    <!--Footer: Paginación-->
                    <template v-slot:[`footer.page-text`]="items">
                      {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                    </template>
                  </v-data-table>

                </v-card-text>
              </v-card>
          </app-page-card>
      </app-col>
  </app-row>
</v-container>
</template>

<script>
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import AppContainer from '@/components/layout/AppContainer.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import HideDeletedSwitch from '@/components/HideDeletedSwitch.vue';
import { mapGetters } from "vuex";
import {VueBankStatisticScreenData} from '@/modules/bank/infra/VueBankStatisticScreenData'
import {ApiBankStatisticRepository} from '@/modules/bank/infra/ApiBankStatisticRepository'
import {ApiBankDeliveryRepository} from '@/modules/bank/infra/ApiBankDeliveryRepository'
import { BankStatisticsComponent } from '@/modules/bank/application/BankStatisticsComponent';


export default {
  name: 'DashboardBank',
  components: {
    AppPageCard,
    AppContainer,
    AppCol,
    AppRow,
    AppSelect,
    HideDeletedSwitch
  },
  data() {
    const screen_data = new VueBankStatisticScreenData();
    return {
      screen_data: screen_data,
      bank_statistic_component: null,
      search:"",
      hideDeleted: true,
      contract: {id: 0, date_name: 'Todos los contratos'},

      headers: [
        {
          text: 'Empresa',
          align: 'start',
          value: 'name',
        },
        // { text: 'Borrada', value: 'del' },
        { text: 'Todos', value: 'all' },
        { text: 'Contabilizado', value: 'done' },
        { text: 'Borrador', value: 'draft' },
        { text: 'Errores', value: 'errors' },
        { text: 'Importados', value: 'imported' },
        { text: 'Borrados', value: 'deleted' },
        { text: 'Contabilizados Borrados', value: 'deleted_done' },   
        { text: 'Pendiente Sincronización', value: 'pending_sync' },
        { text: 'Pendiente contabilización', value: 'pending_accounting' },   
      ]
    }
  },
  computed:{    
    ...mapGetters({
      userData: 'me/userData',
      got_feature: 'got_feature',
    }),
    stats_items() {
      const items = []
      if (this.screen_data.statistics) {
        this.screen_data.statistics.forEach(elm => {
          if (elm.company_name === 'Total') {
            return
          }
          if (this.hideDeleted && elm.deleted) {
            return
          }
          const newRow = this.createStatsRow(elm)
          items.push(newRow)
        })
      }
      return items;
    },
    total() {
      const total = {}
      this.headers.forEach(h => { total[h.value] = 0 })
      total['name'] = 'Total'
      this.stats_items.forEach(item => {
        this.headers.forEach(h => {
          if (h.value !== 'name' && typeof item[h.value] === 'number') {
            total[h.value] += item[h.value]
          }
        })
      })
      return total
    },
    contract_items() {
      const items = [];
      items.push({id: 0, date_name: 'Todos los contratos'});
      if (this.screen_data.contracts) {        
        this.screen_data.contracts.forEach(elm => {
          const newRow =
            {
              id: elm.id,
              date_name: elm.name + " " + elm.start_date + " " + elm.end_date,              
            }
          items.push(newRow)
        })
      }      
      return items;
    }
  },

  async created() {
    let bank_stats_repo = new ApiBankStatisticRepository()
    let bank_delivery_repo = new ApiBankDeliveryRepository()

    let contracts = await bank_delivery_repo.get_data(this.userData.user)
    this.screen_data.setContracts(contracts)

    let stats = await bank_stats_repo.get_data()
    this.screen_data.setStatistics(stats)  

    this.bank_statistic_component = new BankStatisticsComponent(bank_stats_repo, bank_delivery_repo, this.screen_data)
    console.log("Fin created");
  },

  methods: {
    async setData(contract) {
      this.bank_statistic_component.get_bank_statistics(contract);
    },
    createStatsRow(elm) {
      const newRow = {
        name: elm.company_name,
        del: elm.deleted,
        all: elm.states.all,
        done: elm.states.done,
        draft: elm.states.draft,
        errors: elm.states.errors,
        imported: elm.states.imported,
        deleted: elm.states.deleted,
        deleted_done: elm.states.deleted_done,
        pending_sync: elm.states.pending_sync,
        pending_accounting: elm.states.pending_accounting,        
      }
      return newRow
    }
  }
}
</script>

<style scoped>
.card-title-footer-color {
    background: #FAFAFF;
}
::v-deep .v-data-table-header > tr > th > span{
    color: var(--v-primary-base);
}
::v-deep .v-data-table-header > tr > th{
    background-color: var(--v-primaryLight-base) !important;
}
</style>